// eslint-disable-next-line import/prefer-default-export
export const SortOrderType = Object.freeze({
    Ascending: 0,
    Descending: 1,
});
